import {
  getTypeOfUser,
  pharmacistEvent,
  TypeOfUser,
  workshiftData,
} from '@pharmaplan/common';

import useAdminWorkshiftDropdowns from '../Admin/Workshift/useAdminWorkshiftDropdowns';
import { useAppSelector } from '../useAppSelector';
import useAdmin from '../useAdmin';

const { pharmacy, admin, superAdmin, pharmacyAdmin } = TypeOfUser;
interface IUseAdminWorkshiftDropdowns {
  pharmacyId?: string;
  useApi?: boolean;
  isAutoSyncRecord?: boolean
}

const useAllowanceWorkshiftDropdowns = ({ pharmacyId, isAutoSyncRecord, useApi }: IUseAdminWorkshiftDropdowns) => {
  const userType = useAppSelector(getTypeOfUser);
  const { isAdmin } = useAdmin();

  const workshiftUtils = useAppSelector(workshiftData);
  const {
    allTravelAllowanceTypes = [],
    accommodationAllowanceTypes: pharmacistAccommodationTypes = [],
  } = useAppSelector(pharmacistEvent);

  const {
    travelAllowanceTypes: pharmacyTravelAllowanceTypes = [],
    accommodationAllowanceTypes: pharmacyAccommodationAllowanceTypes = [],
  } = workshiftUtils ?? {};

  const { travelAllowanceDropdown, accommodationAllowanceDropdown } = useAdminWorkshiftDropdowns({
    pharmacyId,
    useApi: isAdmin && useApi,
    isAutoSyncRecord,
  });

  const dropdowns = () => {
    switch (userType) {
      case pharmacy:
      case pharmacyAdmin:
        return {
          accommodationDropdowns: pharmacyAccommodationAllowanceTypes,
          travelDropdowns: pharmacyTravelAllowanceTypes,
        };
      case admin:
      case superAdmin:
        return {
          accommodationDropdowns: accommodationAllowanceDropdown,
          travelDropdowns: travelAllowanceDropdown,
        };
      default:
        return {
          accommodationDropdowns: pharmacistAccommodationTypes,
          travelDropdowns: allTravelAllowanceTypes,
        };
    }
  };

  return dropdowns();
};

export default useAllowanceWorkshiftDropdowns;
